/**
 * Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input, OnInit } from '@angular/core';
import { PasswordComplexity } from '../../../state/authState.model';

@Component({
    selector: 'dash-gis-password-complexity',
    templateUrl: './password-complexity.component.html',
    styleUrls: [ './password-complexity.component.scss' ]
})
export class PasswordComplexityComponent implements OnInit {

    @Input() complexity: PasswordComplexity = null;

    constructor() {}

    ngOnInit() {}


    get score(): number {
        return this.complexity?.score;
    }

    get warning(): string {
        return this.complexity?.feedback?.warning;
    }

    get suggestions(): string[] {
        const suggestions = this.complexity?.feedback?.suggestions;
        if (Array.isArray(suggestions)) {
            return suggestions;
        } else {
            return [];
        }
    }
}
